export default class OeffnungRequest {
  filialeId: string
  terminart: string
}
